import * as React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import { TextP } from '../../..';
import { Title } from '../../Zemplin/General/Title';
// @ts-ignore
import * as imgSrc from '../../../../assets/dsi/images/desc-image.png';

interface Props {
  isOpen: boolean;
  description: string;
}

function Description(props) {
  const { description, isOpen } = props;
  return (
    <>
      <Wrapper isOpen={isOpen}>
        <StyledTitle
          marginBottom={32}
        >{`Vyberte. Pripojte. Prehrávajte.`}</StyledTitle>
        <FullDescription>{`${description}`}</FullDescription>
        <Img src={imgSrc.toString()} />
        <StyledTitle marginBottom={32}>{`Funkcie`}</StyledTitle>
        <StyledUl>
          <li>JBL Pure Bass zvuk</li>
          <li>Diaľkový ovládač/mikrofón s jednýmtlačidlom</li>
          <li>Ľahký a sklápací dizajn</li>
          <li>Plochý kábel odolný voči zamotaniu</li>
          <li>Ask Siri alebo Google Now</li>
        </StyledUl>
      </Wrapper>
    </>
  );
}

export const Wrapper = styled.div<{ isOpen: boolean }>`
  display: ${({ isOpen }) => (!isOpen ? 'none' : 'block')};
  padding: ${rem(56)} ${rem(232)};
`;

export const StyledTitle = styled(Title)`
  font-size: ${rem(24)};
`;

const FullDescription = styled(TextP)`
  margin-bottom: ${rem(48)};
`;

const Img = styled.img`
  width: 100%;
  border-radius: ${rem(4)};
`;

const StyledUl = styled.ul`
  padding-left: ${rem(20)};
  list-style-type: square;
`;

export { Description as DsiDescription };
